import React, {useState} from 'react'
import HeroWaitlist from './HeroWaitlist'
import FeaturesSection from '../FeaturesSection'
import Footer from '../Footer'
import SuccessModal from '../SuccessModal'
import Waitlist from './Waitlist'
import {logSgc, setExtensionParamsToLocalStorage} from '../../../../util/extensionMetadata'
import {useOnce} from '../../../../util/customHooks'
import {EVENTS, logDplWithExtensionParams} from '../../../../util/dpl'
import SEO from '../../../seo'
import {getCountry} from '../../../../util/getCountry'

const BrowserWaitlistV1 = ({experimentId, os, browser, languageCode}) => {
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useOnce(() => {
        window.addEventListener('showSuccessModal', (e) => {
            const {ctaType} = e.detail
            logDplWithExtensionParams(EVENTS.StartpageBrowserInstallSuccess, {experiment: experimentId, type: ctaType})
            setShowSuccessModal(true)
        })
        window.addEventListener('hideSuccessModal', () => {
            setShowSuccessModal(false)
        })
        setExtensionParamsToLocalStorage(experimentId).then(() => {
            logDplWithExtensionParams(EVENTS.StartpagePageLoad, {
                os,
                browser,
                country: getCountry(),
                experiment: experimentId,
            })
            logSgc()
        })
    })

    return (
        <>
            <SEO
                title="Install Startpage Browser"
                description="The desktop browsing app is here. Simple. Stealth. Secure."
                ogImagePath="https://www.startpage.com/sp/cdn/images/startpage-shield.png"
            />
            <HeroWaitlist experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
            <FeaturesSection languageCode={languageCode} />
            <Waitlist languageCode={languageCode} />
            <Footer languageCode={languageCode} />
            <SuccessModal show={showSuccessModal} languageCode={languageCode} />
        </>
    )
}

export default BrowserWaitlistV1
